module.exports = __webpack_public_path__ + "static/img/kg.1cfa1c79.svg";